import { DirectiveOptions } from 'vue';
import store from '../store';

const anchor: DirectiveOptions = {
    bind: (el, { value: { id, name } }, vNode): void => {
        store.commit('ui/addScrollAnchor', { el: vNode, id, name });
    },
    unbind: (el, { value: { id } }): void => {
        store.commit('ui/removeScrollAnchor', { id });
    },
};

export default anchor;
